import { createCarousel, CarouselConfig } from "utils/carousel"
import "./carousel-freshsnowdepth.scss"
import "./carousel-powderreported.scss"
import "./carousel-snow0to3mid.scss"
import "./resort-picks.scss"

require.context("./static", true, /\.jpg|svg$/)

// Component-specific configuration
const freshSnowConfig: CarouselConfig = {
  carouselSelector: ".carousel-freshsnowdepth__carousel",
  slideSelector: ".carousel-freshsnowdepth__slide",
  slideGap: 20,
  cssClass: "carousel-freshsnowdepth",
}

const powderReportedConfig: CarouselConfig = {
  carouselSelector: ".carousel-powderreported__carousel",
  slideSelector: ".carousel-powderreported__slide",
  slideGap: 20,
  cssClass: "carousel-powderreported",
}

const snow0to3midConfig: CarouselConfig = {
  carouselSelector: ".carousel-snow0to3mid__carousel",
  slideSelector: ".carousel-snow0to3mid__slide",
  slideGap: 20,
  cssClass: "carousel-snow0to3mid",
}

// Export the configured carousel instance
export const CarouselFreshSnow = createCarousel(freshSnowConfig)
export const CarouselPowderReported = createCarousel(powderReportedConfig)
export const CarouselSnow0to3Mid = createCarousel(snow0to3midConfig)
